// The toast context and its hook — apart from the provider so the
// component file exports components only (fast refresh).

import {createContext, useContext} from "react";

export interface Toast {
  id: number;
  kind: "ok" | "warn" | "error";
  text: string;
  action?: {label: string; run: () => void | Promise<void>};
}

export interface ToastApi {
  ok: (text: string, action?: Toast["action"]) => void;
  warn: (text: string, action?: Toast["action"]) => void;
  error: (text: string) => void;
}

export const ToastCtx = createContext<ToastApi | null>(null);

export function useToasts(): ToastApi {
  const api = useContext(ToastCtx);
  if (!api) throw new Error("ToastProvider missing");
  return api;
}
